import Aura from '@primeuix/themes/aura';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpLoaderFactory, Languages } from './app.i18n';
import { AuthInterceptor } from './core/auth/auth.interceptor';
import { CoreModule } from './core/core.module';
import { NavigationModule } from './navigation/navigation.module';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AppInitializerService } from './app-initializer/app-initializer.service';
import { SharedModule } from './shared/shared.module';
import { providePrimeNG } from 'primeng/config';

export function translateFactory(translate: TranslateService) {
    return async () => {
        translate.setDefaultLang('EN');
        translate.use('EN');
        return new Promise<void>(resolve => {
            translate.onLangChange.subscribe(() => {
                resolve();
            });
        });
    };
}
@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NavigationModule,
        ToastModule,
        CoreModule,
        TranslateModule.forRoot({
            defaultLanguage: Languages.EN,
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({ connectInZone: true }),
        SharedModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: translateFactory,
            deps: [TranslateService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (appInitializerService: AppInitializerService) => () => appInitializerService.init(),
            deps: [AppInitializerService],
            multi: true
        },
        MessageService,
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    prefix: 'p',
                    darkModeSelector: false,
                    cssLayer: {
                        name: 'primeng',
                        order: 'primeng'
                    }
                }
            }
        })
    ]
})
export class AppModule {}
